import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Handlebars = ({
  height = 18,
  width = 18,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M16.875 16.3147C16.875 16.6131 16.7565 16.8992 16.5455 17.1102C16.3345 17.3212 16.0484 17.4397 15.75 17.4397H2.25C1.95163 17.4397 1.66548 17.3212 1.4545 17.1102C1.24353 16.8992 1.125 16.6131 1.125 16.3147V1.6897C1.125 1.39133 1.24353 1.10518 1.4545 0.894202C1.66548 0.683224 1.95163 0.564697 2.25 0.564697H13.5338C13.8275 0.564732 14.1096 0.67967 14.3198 0.884947L16.536 3.04645C16.6434 3.15131 16.7287 3.2766 16.7869 3.41493C16.8451 3.55327 16.8751 3.70186 16.875 3.85195V16.3147Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.875 6.18968H7.3125C7.035 6.17084 6.76126 6.26217 6.55065 6.44385C6.34005 6.62553 6.20956 6.88292 6.1875 7.16018V8.09543C6.18297 8.26227 6.13419 8.42491 6.04616 8.5667C5.95813 8.7085 5.83401 8.82436 5.6865 8.90243L4.5 9.58493L5.6865 10.2667C5.83391 10.3449 5.95795 10.4608 6.04596 10.6025C6.13397 10.7443 6.18281 10.9069 6.1875 11.0737V12.0097C6.20956 12.2869 6.34007 12.5442 6.5507 12.7258C6.76133 12.9073 7.03507 12.9985 7.3125 12.9794H7.875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.125 6.18973H10.6875C10.965 6.17069 11.2389 6.26195 11.4495 6.44367C11.6602 6.62539 11.7906 6.88289 11.8125 7.16023V8.09548C11.817 8.26232 11.8658 8.42496 11.9538 8.56675C12.0419 8.70855 12.166 8.82441 12.3135 8.90248L13.5 9.58498L12.3135 10.2667C12.1661 10.3449 12.0421 10.4608 11.954 10.6026C11.866 10.7444 11.8172 10.9069 11.8125 11.0737V12.0097C11.7904 12.2869 11.6599 12.5443 11.4493 12.7258C11.2387 12.9074 10.9649 12.9985 10.6875 12.9795H10.125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
